// // EWODiscripency.js
// import React, { useEffect, useState } from "react";
// import { styled } from "@mui/material/styles";
// import {
//   Box,
//   Typography,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Button,
//   TextField,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   InputAdornment,
//   Skeleton,
// } from "@mui/material";
// import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
// import DownloadIcon from "@mui/icons-material/Download";
// import SearchIcon from "@mui/icons-material/Search";
// import { useDispatch, useSelector } from "react-redux";
// import { LocalizationProvider } from "@mui/x-date-pickers";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
// import {
//   fetchEWODiscripency,
//   fetchIWOWithoutEWO,
//   fetchEWOWithoutInvoice,
// } from "../../actions/EWODiscripencyAction";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
// import homeImage from "../../assets/DTS2.png";

// // ─── View options ─────────────────────────────────────────────────────────────
// const VIEW_IWO_WITHOUT_EWO     = "iwoWithoutEwo";
// const VIEW_EWO_WITHOUT_INVOICE = "ewoWithoutInvoice";
// const VIEW_DATE                = "date";

// // ─── PM filter ────────────────────────────────────────────────────────────────
// const ALLOWED_MAINS = new Set([
//   "0002","0003","0004","0005","0011","0012","0013","0014",
//   "0015","0016","0017","0021","0023","0024","0027",
// ]);

// // ─── Styles ───────────────────────────────────────────────────────────────────
// const PageContainer = styled(Box)(() => ({
//   maxWidth: "1100px",
//   margin: "0 auto",
//   padding: "10px 15px",
//   fontFamily: "'Poppins', sans-serif",
// }));

// const StickyCardsContainer = styled(Box)(() => ({
//   position: "sticky",
//   top: 0,
//   backgroundColor: "#ffffff",
//   zIndex: 100,
//   paddingTop: "10px",
//   paddingBottom: "10px",
//   boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
// }));

// const StyledTableContainer = styled(TableContainer)(() => ({
//   borderRadius: "16px",
//   boxShadow: "0px 6px 15px rgba(0,0,0,0.12)",
//   border: "1px solid #d6dce5",
//   backgroundColor: "#ffffff",
//   overflowX: "auto",
//   "& .MuiTable-root": { borderCollapse: "separate", minWidth: "max-content" },
// }));

// const StyledTableCell = styled(TableCell)(() => ({
//   fontFamily: "'Poppins', sans-serif",
//   padding: "12px 14px",
//   fontSize: "13px",
//   textAlign: "center",
//   "&.MuiTableCell-head": {
//     backgroundColor: "#154C79",
//     color: "#FFFFFF",
//     fontWeight: 600,
//     letterSpacing: "0.5px",
//     borderBottom: "none",
//   },
// }));

// const StyledTableRow = styled(TableRow)(() => ({
//   transition: "0.25s ease",
//   "&:nth-of-type(odd)": { backgroundColor: "rgba(243, 246, 250, 0.6)" },
//   "&:hover": { backgroundColor: "rgba(14, 60, 102, 0.09)", cursor: "pointer" },
// }));

// // ─── Hour keys — strip decimals in display and PDF ───────────────────────────
// const HOUR_KEYS = new Set(["TotHrs", "ActHrs"]);

// // ─── Task keys — truncated with tooltip ──────────────────────────────────────
// const TASK_KEYS = new Set(["EngSpec", "EWODis_engSpec"]);

// // Render helper: round hour fields, fallback dash for everything else
// const formatCellValue = (key, value) => {
//   if (value == null || value === "") return "—";
//   if (HOUR_KEYS.has(key)) {
//     const n = Number(value);
//     return isNaN(n) ? value : Math.round(n).toString();
//   }
//   return value;
// };

// // ─── Column configs ───────────────────────────────────────────────────────────
// const COLUMNS = {
//   [VIEW_IWO_WITHOUT_EWO]: [
//     { label: "Cat",        key: "CDLjcat",            align: "center", headerAlign: "center", width: 30  },
//     { label: "Main",       key: "CDLjmain",           align: "center", headerAlign: "center", width: 40  },
//     { label: "Job",        key: "mainJobdes",         align: "left",   headerAlign: "center", width: 130 },
//     { label: "IWO No",     key: "IWONo",              align: "center", headerAlign: "center", width: 40  },
//     { label: "Task",       key: "EngSpec",            align: "left",   headerAlign: "center", width: 200 },
//     { label: "Created",    key: "Date",               align: "center", headerAlign: "center", width: 80  },
//     { label: "Start",      key: "StartDate",          align: "center", headerAlign: "center", width: 80  },
//     { label: "End",        key: "EndDate",            align: "center", headerAlign: "center", width: 80  },
//     { label: "Supervisor", key: "SupervisorInCharge", align: "left",   headerAlign: "center", width: 110 },
//     { label: "Est. Hrs",   key: "TotHrs",             align: "center", headerAlign: "center", width: 30  },
//     { label: "Act. Hrs",   key: "ActHrs",             align: "center", headerAlign: "center", width: 30  },
//   ],
//   [VIEW_EWO_WITHOUT_INVOICE]: [
//     { label: "Cat",        key: "CDLjcat",            align: "center", headerAlign: "center", width: 30  },
//     { label: "Main",       key: "CDLjmain",           align: "center", headerAlign: "center", width: 40  },
//     { label: "Job",        key: "mainJobdes",         align: "left",   headerAlign: "center", width: 130 },
//     { label: "IWO No",     key: "IWONo",              align: "center", headerAlign: "center", width: 40  },
//     { label: "EWO No",     key: "EwoNo",              align: "center", headerAlign: "center", width: 55  },
//     { label: "Task",       key: "EngSpec",            align: "left",   headerAlign: "center", width: 200 },
//     { label: "Created",    key: "Date",               align: "center", headerAlign: "center", width: 80  },
//     { label: "Start",      key: "StartDate",          align: "center", headerAlign: "center", width: 80  },
//     { label: "End",        key: "EndDate",            align: "center", headerAlign: "center", width: 80  },
//     { label: "Supervisor", key: "SupervisorInCharge", align: "left",   headerAlign: "center", width: 110 },
//     { label: "Tot. Hrs",   key: "TotHrs",             align: "center", headerAlign: "center", width: 30  },
//     { label: "Act. Hrs",   key: "ActHrs",             align: "center", headerAlign: "center", width: 30  },
//   ],
//   [VIEW_DATE]: [
//     { label: "IWO No",     key: "EWODis_iwoNo",  align: "center", headerAlign: "center", width: 100 },
//     { label: "Supervisor", key: "EWODis_supName", align: "left",   headerAlign: "center", width: 220 },
//     { label: "Task",       key: "EWODis_engSpec", align: "left",   headerAlign: "center", width: 200 },
//   ],
// };

// // ─── Component ────────────────────────────────────────────────────────────────
// export default function EWODiscripency() {
//   const dispatch = useDispatch();
//   const {
//     loading,
//     data,
//     iwoWithoutEwoLoading,
//     iwoWithoutEwoData,
//     ewoWithoutInvoiceLoading,
//     ewoWithoutInvoiceData,
//   } = useSelector((state) => state.ewoDiscripency);

//   const [view, setView]                     = useState(VIEW_IWO_WITHOUT_EWO);
//   const [openDatePicker, setOpenDatePicker] = useState(false);
//   const [selectedDate, setSelectedDate]     = useState(new Date());
//   const [searchTerm, setSearchTerm]         = useState("");
//   const [selectedRow, setSelectedRow]       = useState(null);

//   // ── Load on mount + when view/date changes ──
//   useEffect(() => {
//     if (view === VIEW_IWO_WITHOUT_EWO)     dispatch(fetchIWOWithoutEWO());
//     if (view === VIEW_EWO_WITHOUT_INVOICE) dispatch(fetchEWOWithoutInvoice());
//     if (view === VIEW_DATE)                dispatch(fetchEWODiscripency(formatDate(selectedDate)));
//   }, [dispatch, view, selectedDate]);

//   // Reset search and selection when view changes
//   useEffect(() => {
//     setSearchTerm("");
//     setSelectedRow(null);
//   }, [view]);

//   // ── Helpers ──
//   const formatDate = (dateObj) => new Date(dateObj).toISOString().split("T")[0];
//   const formatTime = (dateObj) =>
//     new Date(dateObj).toLocaleTimeString("en-GB", {
//       hour: "2-digit", minute: "2-digit", second: "2-digit",
//     });

//   const handleDateChange = (date) => {
//     setSelectedDate(date);
//     setOpenDatePicker(false);
//   };

//   // ── Active raw data ──
//   const activeLoading =
//     view === VIEW_IWO_WITHOUT_EWO     ? iwoWithoutEwoLoading    :
//     view === VIEW_EWO_WITHOUT_INVOICE ? ewoWithoutInvoiceLoading :
//     loading;

//   const activeRaw =
//     view === VIEW_IWO_WITHOUT_EWO     ? iwoWithoutEwoData      :
//     view === VIEW_EWO_WITHOUT_INVOICE ? ewoWithoutInvoiceData   :
//     data;

//   // ── Step 1: Filter Cat = PM and allowed mains (only for non-date views) ──
//   const pmFilteredData = React.useMemo(() => {
//     if (!activeRaw?.length) return [];
//     if (view === VIEW_DATE) return activeRaw; // no PM filter on date view
//     return activeRaw.filter(
//       (item) => item.Cat === "PM" && ALLOWED_MAINS.has(item.Main)
//     );
//   }, [activeRaw, view]);

//   // ── Step 2: Sort by EndDate ascending ──
//   const sortedData = React.useMemo(() => {
//     if (!pmFilteredData.length) return [];
//     const endDateKey = view === VIEW_DATE ? null : "EndDate";
//     if (!endDateKey) return pmFilteredData; // date view: no EndDate sort
//     return [...pmFilteredData].sort((a, b) => {
//       const dateA = a[endDateKey] ? new Date(a[endDateKey]) : new Date(0);
//       const dateB = b[endDateKey] ? new Date(b[endDateKey]) : new Date(0);
//       return dateA - dateB;
//     });
//   }, [pmFilteredData, view]);

//   // ── Step 3: Search filter on mainJobdes, CDLjcat, CDLjmain ──
//   const filteredData = React.useMemo(() => {
//     if (!searchTerm.trim()) return sortedData;
//     const term = searchTerm.trim().toLowerCase();
//     return sortedData.filter((item) => {
//       const jobDes = (item.mainJobdes  || "").toLowerCase();
//       const cat    = (item.CDLjcat     || "").toLowerCase();
//       const main   = (item.CDLjmain    || "").toLowerCase();
//       return jobDes.includes(term) || cat.includes(term) || main.includes(term);
//     });
//   }, [sortedData, searchTerm]);

//   const columns      = COLUMNS[view];
//   const totalRecords = filteredData.length;

//   // ── PDF Export ──
//   const handleExportPDF = () => {
//     const doc         = new jsPDF("l", "mm", "a4");
//     const generatedAt = new Date();
//     const pageWidth   = doc.internal.pageSize.getWidth();

//     doc.addImage(homeImage, "PNG", 0, 0, pageWidth, 55);

//     const titleMap = {
//       [VIEW_IWO_WITHOUT_EWO]:     "IWO Without EWO Report",
//       [VIEW_EWO_WITHOUT_INVOICE]: "EWO Without Invoice Report",
//       [VIEW_DATE]:                "EWO Discrepancy Report",
//     };

//     doc.setFontSize(18);
//     doc.setFont("helvetica", "bold");
//     doc.setTextColor(21, 76, 121);
//     doc.text(titleMap[view], pageWidth / 2, 65, { align: "center" });

//     doc.setDrawColor(21, 76, 121);
//     doc.setLineWidth(0.5);
//     doc.line(15, 70, pageWidth - 15, 70);

//     doc.setFontSize(11);
//     doc.setFont("helvetica", "normal");
//     doc.setTextColor(60, 60, 60);

//     const yMeta = 78;
//     const mid   = pageWidth / 2;

//     doc.setFont("helvetica", "bold");
//     doc.text("Generated:", mid - 80, yMeta);
//     doc.setFont("helvetica", "normal");
//     doc.text(`${formatDate(generatedAt)}  ${formatTime(generatedAt)}`, mid - 50, yMeta);

//     doc.setFont("helvetica", "bold");
//     doc.text("Total Records:", mid + 50, yMeta);
//     doc.setFont("helvetica", "normal");
//     doc.text(String(totalRecords), mid + 90, yMeta);

//     if (searchTerm.trim()) {
//       doc.setFont("helvetica", "bold");
//       doc.text("Search Filter:", mid - 80, yMeta + 8);
//       doc.setFont("helvetica", "normal");
//       doc.text(`"${searchTerm.trim()}"`, mid - 45, yMeta + 8);
//     }

//     const pdfColumns = columns.map((c) => c.label);
//     const pdfRows    = filteredData.map((item) =>
//       columns.map((c) => formatCellValue(c.key, item[c.key]))
//     );

//     autoTable(doc, {
//       head: [pdfColumns],
//       body: pdfRows,
//       startY: searchTerm.trim() ? 93 : 85,
//       styles: {
//         fontSize: 9,
//         cellPadding: 4,
//         lineColor: [220, 220, 220],
//         lineWidth: 0.1,
//       },
//       headStyles: {
//         fillColor: [21, 76, 121],
//         textColor: [255, 255, 255],
//         fontStyle: "bold",
//         halign: "center",
//         cellPadding: 5,
//       },
//       alternateRowStyles: { fillColor: [248, 249, 252] },
//       margin: { left: 13, right: 13 },
//       theme: "grid",
//       didDrawPage: (d) => {
//         doc.setFontSize(8);
//         doc.setTextColor(150);
//         doc.setFont("helvetica", "italic");
//         doc.text(
//           `Generated on ${formatDate(generatedAt)} at ${formatTime(generatedAt)}`,
//           pageWidth / 2,
//           doc.internal.pageSize.getHeight() - 10,
//           { align: "center" }
//         );
//         doc.text(
//           `Page ${d.pageNumber}`,
//           pageWidth - 20,
//           doc.internal.pageSize.getHeight() - 10
//         );
//       },
//     });

//     const filePrefix = {
//       [VIEW_IWO_WITHOUT_EWO]:     "IWO_Without_EWO",
//       [VIEW_EWO_WITHOUT_INVOICE]: "EWO_Without_Invoice",
//       [VIEW_DATE]:                `EWO_Discrepancy_${formatDate(selectedDate)}`,
//     };
//     doc.save(`${filePrefix[view]}_${formatDate(new Date())}.pdf`);
//   };

//   // ─── Render ──────────────────────────────────────────────────────────────────
//   return (
//     <LocalizationProvider dateAdapter={AdapterDateFns}>
//       <PageContainer>
//         <Typography
//           sx={{
//             fontSize: "20px",
//             fontWeight: 700,
//             color: "#0e3c66",
//             textAlign: "center",
//             mb: 2,
//           }}
//         >
//           EWO Discrepancy
//         </Typography>

//         {!activeLoading && (
//           <StickyCardsContainer>
//             {/* ── Row 1: View dropdown | Date button | Total ── */}
//             <Box
//               sx={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 1.5,
//                 mb: 1,
//                 flexWrap: "nowrap",
//               }}
//             >
//               {/* View selector */}
//               <FormControl size="small" sx={{ minWidth: 200, flexShrink: 0 }}>
//                 <InputLabel sx={{ fontFamily: "'Poppins', sans-serif" }}>View</InputLabel>
//                 <Select
//                   value={view}
//                   label="View"
//                   onChange={(e) => setView(e.target.value)}
//                   sx={{
//                     borderRadius: "20px",
//                     fontFamily: "'Poppins', sans-serif",
//                     height: "44px",
//                   }}
//                 >
//                   <MenuItem value={VIEW_IWO_WITHOUT_EWO}>IWO Without EWO</MenuItem>
//                   <MenuItem value={VIEW_EWO_WITHOUT_INVOICE}>EWO Without Invoice</MenuItem>
//                   <MenuItem value={VIEW_DATE}>By Date</MenuItem>
//                 </Select>
//               </FormControl>

//               {/* Date picker — only shown in By Date view */}
//               {view === VIEW_DATE && (
//                 <Button
//                   variant="contained"
//                   startIcon={<CalendarTodayIcon />}
//                   onClick={() => setOpenDatePicker(true)}
//                   sx={{
//                     height: "44px",
//                     borderRadius: "20px",
//                     backgroundColor: "#142c54",
//                     fontWeight: "bold",
//                     textTransform: "none",
//                     whiteSpace: "nowrap",
//                     flexShrink: 0,
//                     px: 2,
//                   }}
//                 >
//                   {formatDate(selectedDate)}
//                 </Button>
//               )}

//               {/* Total */}
//               <Box
//                 sx={{
//                   background: "#e8f0fa",
//                   borderRadius: "20px",
//                   height: "44px",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   px: 2.5,
//                   flexShrink: 0,
//                 }}
//               >
//                 <Typography sx={{ fontWeight: 700, fontSize: "14px", color: "#142c54", whiteSpace: "nowrap" }}>
//                   Total: {totalRecords}
//                   {searchTerm.trim() && sortedData.length !== totalRecords && (
//                     <Typography
//                       component="span"
//                       sx={{ fontWeight: 400, fontSize: "12px", color: "#666", ml: 1 }}
//                     >
//                       (of {sortedData.length})
//                     </Typography>
//                   )}
//                 </Typography>
//               </Box>
//             </Box>

//             {/* ── Row 2: Export PDF (full width) ── */}
//             {filteredData.length > 0 && (
//               <Box sx={{ mb: 1 }}>
//                 <Button
//                   variant="contained"
//                   startIcon={<DownloadIcon />}
//                   onClick={handleExportPDF}
//                   disabled={activeLoading || !filteredData.length}
//                   sx={{
//                     width: "100%",
//                     height: "44px",
//                     borderRadius: "20px",
//                     backgroundColor: "#2e7d32",
//                     color: "#fff",
//                     fontWeight: "bold",
//                     textTransform: "none",
//                     fontSize: "15px",
//                     "&:hover": { backgroundColor: "#1b5e20" },
//                     "&:disabled": { backgroundColor: "#cccccc", color: "#666666" },
//                   }}
//                 >
//                   Export PDF
//                 </Button>
//               </Box>
//             )}

//             {/* Search bar */}
//             <Box sx={{ mb: 1 }}>
//               <TextField
//                 fullWidth
//                 size="small"
//                 placeholder="Search by Job Description, Cat or Main..."
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <SearchIcon sx={{ color: "#154C79" }} />
//                     </InputAdornment>
//                   ),
//                   sx: {
//                     borderRadius: "20px",
//                     fontFamily: "'Poppins', sans-serif",
//                     fontSize: "14px",
//                     height: "44px",
//                     backgroundColor: "#f5f7fb",
//                     "& fieldset": { borderColor: "#d0d9e8" },
//                     "&:hover fieldset": { borderColor: "#154C79" },
//                     "&.Mui-focused fieldset": { borderColor: "#154C79" },
//                   },
//                 }}
//               />
//             </Box>

//             {openDatePicker && (
//               <DatePicker
//                 open={openDatePicker}
//                 value={selectedDate}
//                 onChange={handleDateChange}
//                 onClose={() => setOpenDatePicker(false)}
//                 renderInput={(params) => (
//                   <TextField {...params} sx={{ display: "none" }} />
//                 )}
//               />
//             )}
//           </StickyCardsContainer>
//         )}

//         <Box sx={{ mt: 2 }}>
//           <StyledTableContainer component={Paper}>
//             <Table>
//               <TableHead>
//               <TableRow>
//                 {columns.map((col) => (
//                   <StyledTableCell
//                     key={col.key}
//                     sx={{
//                       textAlign: col.headerAlign,
//                       whiteSpace: "nowrap",
//                       minWidth: col.width ? `${col.width}px` : undefined,
//                     }}
//                   >
//                     {col.label}
//                   </StyledTableCell>
//                 ))}
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {activeLoading ? (
//                 Array.from({ length: 6 }).map((_, rowIndex) => (
//                   <TableRow key={`skeleton-${rowIndex}`}>
//                     {columns.map((col) => (
//                       <StyledTableCell
//                         key={col.key}
//                         sx={{
//                           minWidth: col.width ? `${col.width}px` : undefined,
//                         }}
//                       >
//                         <Skeleton
//                           variant="text"
//                           animation="wave"
//                           width="80%"
//                           sx={{
//                             mx: col.align === "center" ? "auto" : col.align === "right" ? "0 0 0 auto" : 0,
//                           }}
//                         />
//                       </StyledTableCell>
//                     ))}
//                   </TableRow>
//                 ))
//               ) : filteredData.length > 0 ? (
//                 filteredData.map((item, index) => (
//                   <StyledTableRow
//                     key={index}
//                     onClick={() => setSelectedRow(selectedRow === index ? null : index)}
//                     sx={
//                       selectedRow === index
//                         ? {
//                             backgroundColor: "rgba(21, 76, 121, 0.18) !important",
//                             outline: "2px solid #154C79",
//                             outlineOffset: "-2px",
//                           }
//                         : {}
//                     }
//                   >
//                     {columns.map((col) => (
//                       <StyledTableCell
//                         key={col.key}
//                         sx={{
//                           textAlign: col.align,
//                           minWidth: col.width ? `${col.width}px` : undefined,
//                           whiteSpace: TASK_KEYS.has(col.key) ? "normal" : "nowrap",
//                           maxWidth: TASK_KEYS.has(col.key) ? "200px" : undefined,
//                           wordBreak: TASK_KEYS.has(col.key) ? "break-word" : undefined,
//                           lineHeight: TASK_KEYS.has(col.key) ? 1.6 : undefined,
//                         }}
//                       >
//                         {formatCellValue(col.key, item[col.key])}
//                       </StyledTableCell>
//                     ))}
//                   </StyledTableRow>
//                 ))
//               ) : (
//                 <TableRow>
//                   <StyledTableCell colSpan={columns.length}>
//                     {searchTerm.trim()
//                       ? `No records match "${searchTerm}"`
//                       : "No Records Found"}
//                   </StyledTableCell>
//                 </TableRow>
//               )}
//             </TableBody>
//             </Table>
//           </StyledTableContainer>
//         </Box>
//       </PageContainer>
//     </LocalizationProvider>
//   );
// }
// EWODiscripency.js
import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  InputAdornment,
  Skeleton,
} from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import DownloadIcon from "@mui/icons-material/Download";
import SearchIcon from "@mui/icons-material/Search";
import { useDispatch, useSelector } from "react-redux";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import {
  fetchEWODiscripency,
  fetchIWOWithoutEWO,
  fetchEWOWithoutInvoice,
} from "../../actions/EWODiscripencyAction";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import ExcelJS from "exceljs";
import homeImage from "../../assets/DTS2.png";

// ─── View options ─────────────────────────────────────────────────────────────
const VIEW_IWO_WITHOUT_EWO     = "iwoWithoutEwo";
const VIEW_EWO_WITHOUT_INVOICE = "ewoWithoutInvoice";
const VIEW_DATE                = "date";

// ─── PM filter ────────────────────────────────────────────────────────────────
const ALLOWED_MAINS = new Set([
  "0002","0003","0004","0005","0011","0012","0013","0014",
  "0015","0016","0017","0021","0023","0024","0027",
]);

// ─── Styles ───────────────────────────────────────────────────────────────────
const PageContainer = styled(Box)(() => ({
  maxWidth: "1100px",
  margin: "0 auto",
  padding: "10px 15px",
  fontFamily: "'Poppins', sans-serif",
}));

const StickyCardsContainer = styled(Box)(() => ({
  position: "sticky",
  top: 0,
  backgroundColor: "#ffffff",
  zIndex: 100,
  paddingTop: "10px",
  paddingBottom: "10px",
  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
}));

const StyledTableContainer = styled(TableContainer)(() => ({
  borderRadius: "16px",
  boxShadow: "0px 6px 15px rgba(0,0,0,0.12)",
  border: "1px solid #d6dce5",
  backgroundColor: "#ffffff",
  overflowX: "auto",
  "& .MuiTable-root": { borderCollapse: "separate", minWidth: "max-content" },
}));

const StyledTableCell = styled(TableCell)(() => ({
  fontFamily: "'Poppins', sans-serif",
  padding: "12px 14px",
  fontSize: "13px",
  textAlign: "center",
  "&.MuiTableCell-head": {
    backgroundColor: "#154C79",
    color: "#FFFFFF",
    fontWeight: 600,
    letterSpacing: "0.5px",
    borderBottom: "none",
  },
}));

const StyledTableRow = styled(TableRow)(() => ({
  transition: "0.25s ease",
  "&:nth-of-type(odd)": { backgroundColor: "rgba(243, 246, 250, 0.6)" },
  "&:hover": { backgroundColor: "rgba(14, 60, 102, 0.09)", cursor: "pointer" },
}));

// ─── Hour keys — strip decimals in display and PDF ───────────────────────────
const HOUR_KEYS = new Set(["TotHrs", "ActHrs"]);

const TASK_KEYS = new Set(["EngSpec", "EWODis_engSpec"]);

// ─── Excel header labels (match the reference report exactly) ────────────────
const EXCEL_COLUMN_LABELS = {
  [VIEW_IWO_WITHOUT_EWO]: {
    CDLjcat: "CDL-J Cat", CDLjmain: "CDL J-Main", mainJobdes: "Job",
    IWONo: "IWO No", EngSpec: "Task", Date: "IWO Created",
    StartDate: "Job Start", EndDate: "Job End",
    SupervisorInCharge: "DTS - Supervisor",
    CDLEngineerDisplay: "CDL Engineer", CDLExecutiveLocation: "CDL Location",
    TotHrs: "Est. Hrs", ActHrs: "Act. Hrs",
  },
  [VIEW_EWO_WITHOUT_INVOICE]: {
    CDLjcat: "CDL-J Cat", CDLjmain: "CDL J-Main", mainJobdes: "Job",
    IWONo: "IWO No", EwoNo: "EWO No", EngSpec: "Task", Date: "IWO Created",
    StartDate: "Job Start", EndDate: "Job End",
    SupervisorInCharge: "DTS - Supervisor",
    CDLEngineerDisplay: "CDL Engineer", CDLExecutiveLocation: "CDL Location",
    TotHrs: "Tot. Hrs", ActHrs: "Act. Hrs",
  },
  [VIEW_DATE]: {
    EWODis_iwoNo: "IWO No", EWODis_supName: "Supervisor", EWODis_engSpec: "Task",
  },
};

const EXCEL_CENTER_KEYS = new Set(["CDLjcat", "CDLjmain", "IWONo", "EwoNo", "Date", "CDLExecutiveLocation"]);

const EXCEL_COLUMN_WIDTHS = {
  [VIEW_IWO_WITHOUT_EWO]: {
    CDLjcat: 8.5, CDLjmain: 10, mainJobdes: 33.25, IWONo: 7.625,
    EngSpec: 83.75, Date: 11.375, StartDate: 10.125, EndDate: 8.5,
    SupervisorInCharge: 27.375, CDLEngineerDisplay: 30, CDLExecutiveLocation: 12,
    TotHrs: 10.875, ActHrs: 8.5,
  },
};

const HEADER_FILL = { type: "pattern", pattern: "solid", fgColor: { argb: "FFD9D9D9" } };
const THIN_BORDER = {
  top: { style: "thin" }, left: { style: "thin" },
  bottom: { style: "thin" }, right: { style: "thin" },
};

// Render helper: round hour fields, fallback dash for everything else
const formatCellValue = (key, value) => {
  if (value == null || value === "") return "—";
  if (HOUR_KEYS.has(key)) {
    const n = Number(value);
    return isNaN(n) ? value : Math.round(n).toString();
  }
  return value;
};

// Excel helper: keep hour fields numeric (for sums/averages), blank for empty values
const formatCellValueForExcel = (key, value) => {
  if (value == null || value === "") return "";
  if (HOUR_KEYS.has(key)) {
    const n = Number(value);
    return isNaN(n) ? value : Math.round(n);
  }
  return value;
};

// ─── Column configs ───────────────────────────────────────────────────────────
const COLUMNS = {
  [VIEW_IWO_WITHOUT_EWO]: [
    { label: "Cat",        key: "CDLjcat",            align: "center", headerAlign: "center", width: 30  },
    { label: "Main",       key: "CDLjmain",           align: "center", headerAlign: "center", width: 40  },
    { label: "Job",        key: "mainJobdes",         align: "left",   headerAlign: "center", width: 130 },
    { label: "IWO No",     key: "IWONo",              align: "center", headerAlign: "center", width: 40  },
    { label: "Task",       key: "EngSpec",            align: "left",   headerAlign: "center", width: 200 },
    { label: "Created",    key: "Date",               align: "center", headerAlign: "center", width: 80  },
    { label: "Start",      key: "StartDate",          align: "center", headerAlign: "center", width: 80  },
    { label: "End",        key: "EndDate",            align: "center", headerAlign: "center", width: 80  },
    { label: "Supervisor", key: "SupervisorInCharge", align: "left",   headerAlign: "center", width: 110 },
    { label: "CDL Engineer", key: "CDLEngineerDisplay", align: "left", headerAlign: "center", width: 150 },
    { label: "CDL Location", key: "CDLExecutiveLocation", align: "center", headerAlign: "center", width: 60 },
    { label: "Est. Hrs",   key: "TotHrs",             align: "center", headerAlign: "center", width: 30  },
    { label: "Act. Hrs",   key: "ActHrs",             align: "center", headerAlign: "center", width: 30  },
  ],
  [VIEW_EWO_WITHOUT_INVOICE]: [
    { label: "Cat",        key: "CDLjcat",            align: "center", headerAlign: "center", width: 30  },
    { label: "Main",       key: "CDLjmain",           align: "center", headerAlign: "center", width: 40  },
    { label: "Job",        key: "mainJobdes",         align: "left",   headerAlign: "center", width: 130 },
    { label: "IWO No",     key: "IWONo",              align: "center", headerAlign: "center", width: 40  },
    { label: "EWO No",     key: "EwoNo",              align: "center", headerAlign: "center", width: 55  },
    { label: "Task",       key: "EngSpec",            align: "left",   headerAlign: "center", width: 200 },
    { label: "Created",    key: "Date",               align: "center", headerAlign: "center", width: 80  },
    { label: "Start",      key: "StartDate",          align: "center", headerAlign: "center", width: 80  },
    { label: "End",        key: "EndDate",            align: "center", headerAlign: "center", width: 80  },
    { label: "Supervisor", key: "SupervisorInCharge", align: "left",   headerAlign: "center", width: 110 },
    { label: "CDL Engineer", key: "CDLEngineerDisplay", align: "left", headerAlign: "center", width: 150 },
    { label: "CDL Location", key: "CDLExecutiveLocation", align: "center", headerAlign: "center", width: 60 },
    { label: "Tot. Hrs",   key: "TotHrs",             align: "center", headerAlign: "center", width: 30  },
    { label: "Act. Hrs",   key: "ActHrs",             align: "center", headerAlign: "center", width: 30  },
  ],
  [VIEW_DATE]: [
    { label: "IWO No",     key: "EWODis_iwoNo",  align: "center", headerAlign: "center", width: 100 },
    { label: "Supervisor", key: "EWODis_supName", align: "left",   headerAlign: "center", width: 220 },
    { label: "Task",       key: "EWODis_engSpec", align: "left",   headerAlign: "center", width: 200 },
  ],
};

// ─── Component ────────────────────────────────────────────────────────────────
export default function EWODiscripency() {
  const dispatch = useDispatch();
  const {
    loading,
    data,
    iwoWithoutEwoLoading,
    iwoWithoutEwoData,
    ewoWithoutInvoiceLoading,
    ewoWithoutInvoiceData,
  } = useSelector((state) => state.ewoDiscripency);

  const [view, setView]                     = useState(VIEW_IWO_WITHOUT_EWO);
  const [openDatePicker, setOpenDatePicker] = useState(false);
  const [selectedDate, setSelectedDate]     = useState(new Date());
  const [searchTerm, setSearchTerm]         = useState("");
  const [selectedRow, setSelectedRow]       = useState(null);

  // ── Load on mount + when view/date changes ──
  useEffect(() => {
    if (view === VIEW_IWO_WITHOUT_EWO)     dispatch(fetchIWOWithoutEWO());
    if (view === VIEW_EWO_WITHOUT_INVOICE) dispatch(fetchEWOWithoutInvoice());
    if (view === VIEW_DATE)                dispatch(fetchEWODiscripency(formatDate(selectedDate)));
  }, [dispatch, view, selectedDate]);

  // Reset search and selection when view changes
  useEffect(() => {
    setSearchTerm("");
    setSelectedRow(null);
  }, [view]);

  // ── Helpers ──
  const formatDate = (dateObj) => new Date(dateObj).toISOString().split("T")[0];
  const formatTime = (dateObj) =>
    new Date(dateObj).toLocaleTimeString("en-GB", {
      hour: "2-digit", minute: "2-digit", second: "2-digit",
    });

  const handleDateChange = (date) => {
    setSelectedDate(date);
    setOpenDatePicker(false);
  };

  // ── Active raw data ──
  const activeLoading =
    view === VIEW_IWO_WITHOUT_EWO     ? iwoWithoutEwoLoading    :
    view === VIEW_EWO_WITHOUT_INVOICE ? ewoWithoutInvoiceLoading :
    loading;

  const activeRaw =
    view === VIEW_IWO_WITHOUT_EWO     ? iwoWithoutEwoData      :
    view === VIEW_EWO_WITHOUT_INVOICE ? ewoWithoutInvoiceData   :
    data;


  // ── Step 1: Filter Cat = PM and allowed mains (only for non-date views) ──
  const pmFilteredData = React.useMemo(() => {
    if (!activeRaw?.length) return [];
    const withComputed = activeRaw.map((item) => ({
      ...item,
      CDLEngineerDisplay:
        item.CDLExecutive && item.CDLExecutiveName
          ? `${item.CDLExecutive} - ${item.CDLExecutiveName}`
          : item.CDLExecutiveName || item.CDLExecutive || "",
    }));
    if (view === VIEW_DATE) return withComputed; // no PM filter on date view
    return withComputed.filter(
      (item) => item.Cat === "PM" && ALLOWED_MAINS.has(item.Main)
    );
  }, [activeRaw, view]);

  // ── Step 2: Sort by EndDate ascending ──
  const sortedData = React.useMemo(() => {
    if (!pmFilteredData.length) return [];
    const endDateKey = view === VIEW_DATE ? null : "EndDate";
    if (!endDateKey) return pmFilteredData; // date view: no EndDate sort
    return [...pmFilteredData].sort((a, b) => {
      const dateA = a[endDateKey] ? new Date(a[endDateKey]) : new Date(0);
      const dateB = b[endDateKey] ? new Date(b[endDateKey]) : new Date(0);
      return dateA - dateB;
    });
  }, [pmFilteredData, view]);

  // ── Step 3: Search filter on mainJobdes, CDLjcat, CDLjmain ──
  const filteredData = React.useMemo(() => {
    if (!searchTerm.trim()) return sortedData;
    const term = searchTerm.trim().toLowerCase();
    return sortedData.filter((item) => {
      const jobDes = (item.mainJobdes  || "").toLowerCase();
      const cat    = (item.CDLjcat     || "").toLowerCase();
      const main   = (item.CDLjmain    || "").toLowerCase();
      return jobDes.includes(term) || cat.includes(term) || main.includes(term);
    });
  }, [sortedData, searchTerm]);

  const columns      = COLUMNS[view];
  const totalRecords = filteredData.length;

  // ── Shared export naming ──
  const getFilePrefix = () => {
    const filePrefixMap = {
      [VIEW_IWO_WITHOUT_EWO]:     "IWO_Without_EWO",
      [VIEW_EWO_WITHOUT_INVOICE]: "EWO_Without_Invoice",
      [VIEW_DATE]:                `EWO_Discrepancy_${formatDate(selectedDate)}`,
    };
    return filePrefixMap[view];
  };

  // ── PDF Export ──
  const handleExportPDF = () => {
    const doc         = new jsPDF("l", "mm", "a4");
    const generatedAt = new Date();
    const pageWidth   = doc.internal.pageSize.getWidth();

    doc.addImage(homeImage, "PNG", 0, 0, pageWidth, 55);

    const titleMap = {
      [VIEW_IWO_WITHOUT_EWO]:     "IWO Without EWO Report",
      [VIEW_EWO_WITHOUT_INVOICE]: "EWO Without Invoice Report",
      [VIEW_DATE]:                "EWO Discrepancy Report",
    };

    doc.setFontSize(18);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(21, 76, 121);
    doc.text(titleMap[view], pageWidth / 2, 65, { align: "center" });

    doc.setDrawColor(21, 76, 121);
    doc.setLineWidth(0.5);
    doc.line(15, 70, pageWidth - 15, 70);

    doc.setFontSize(11);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(60, 60, 60);

    const yMeta = 78;
    const mid   = pageWidth / 2;

    doc.setFont("helvetica", "bold");
    doc.text("Generated:", mid - 80, yMeta);
    doc.setFont("helvetica", "normal");
    doc.text(`${formatDate(generatedAt)}  ${formatTime(generatedAt)}`, mid - 50, yMeta);

    doc.setFont("helvetica", "bold");
    doc.text("Total Records:", mid + 50, yMeta);
    doc.setFont("helvetica", "normal");
    doc.text(String(totalRecords), mid + 90, yMeta);

    if (searchTerm.trim()) {
      doc.setFont("helvetica", "bold");
      doc.text("Search Filter:", mid - 80, yMeta + 8);
      doc.setFont("helvetica", "normal");
      doc.text(`"${searchTerm.trim()}"`, mid - 45, yMeta + 8);
    }

    const pdfColumns = columns.map((c) => c.label);
    const pdfRows    = filteredData.map((item) =>
      columns.map((c) => formatCellValue(c.key, item[c.key]))
    );

    autoTable(doc, {
      head: [pdfColumns],
      body: pdfRows,
      startY: searchTerm.trim() ? 93 : 85,
      styles: {
        fontSize: 9,
        cellPadding: 4,
        lineColor: [220, 220, 220],
        lineWidth: 0.1,
      },
      headStyles: {
        fillColor: [21, 76, 121],
        textColor: [255, 255, 255],
        fontStyle: "bold",
        halign: "center",
        cellPadding: 5,
      },
      alternateRowStyles: { fillColor: [248, 249, 252] },
      margin: { left: 13, right: 13 },
      theme: "grid",
      didDrawPage: (d) => {
        doc.setFontSize(8);
        doc.setTextColor(150);
        doc.setFont("helvetica", "italic");
        doc.text(
          `Generated on ${formatDate(generatedAt)} at ${formatTime(generatedAt)}`,
          pageWidth / 2,
          doc.internal.pageSize.getHeight() - 10,
          { align: "center" }
        );
        doc.text(
          `Page ${d.pageNumber}`,
          pageWidth - 20,
          doc.internal.pageSize.getHeight() - 10
        );
      },
    });

    doc.save(`${getFilePrefix()}_${formatDate(new Date())}.pdf`);
  };

  // ── Excel Export ──
  const handleExportExcel = async () => {
    const sheetNameMap = {
      [VIEW_IWO_WITHOUT_EWO]:     "IWO Without EWO",
      [VIEW_EWO_WITHOUT_INVOICE]: "EWO Without Invoice",
      [VIEW_DATE]:                "EWO Discrepancy",
    };

    const workbook  = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(sheetNameMap[view]);
    const labelMap  = EXCEL_COLUMN_LABELS[view] || {};
    const widthMap  = EXCEL_COLUMN_WIDTHS[view] || {};

    worksheet.columns = columns.map((c) => ({
      header: labelMap[c.key] || c.label,
      key: c.key,
      width: widthMap[c.key] || Math.max((labelMap[c.key] || c.label).length + 2, (c.width || 60) / 6),
    }));

    // Header styling
    worksheet.getRow(1).eachCell((cell, colNumber) => {
      const key = columns[colNumber - 1].key;
      cell.font = { name: "Calibri", size: 12, bold: true };
      cell.fill = HEADER_FILL;
      cell.border = THIN_BORDER;
      cell.alignment = { horizontal: EXCEL_CENTER_KEYS.has(key) ? "center" : "general" };
    });

    // Data rows — blank repeated Cat/Main values like the reference report
    let prevCat = null;
    let prevMain = null;
    filteredData.forEach((item) => {
      const rowValues = {};
      columns.forEach((c) => {
        let value = formatCellValueForExcel(c.key, item[c.key]);
        if (view !== VIEW_DATE && c.key === "CDLjcat") {
          if (value === prevCat) value = "";
          else prevCat = value;
        }
        if (view !== VIEW_DATE && c.key === "CDLjmain") {
          if (value === prevMain) value = "";
          else prevMain = value;
        }
        rowValues[c.key] = value;
      });

      const row = worksheet.addRow(rowValues);
      row.eachCell((cell, colNumber) => {
        const key = columns[colNumber - 1].key;
        cell.font = { name: "Calibri", size: 12 };
        cell.border = THIN_BORDER;
        cell.alignment = { horizontal: EXCEL_CENTER_KEYS.has(key) ? "center" : "general" };
      });
    });

    worksheet.views = [{ state: "frozen", ySplit: 1 }];

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${getFilePrefix()}_${formatDate(new Date())}.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  // ─── Render ──────────────────────────────────────────────────────────────────
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <PageContainer>
        <Typography
          sx={{
            fontSize: "20px",
            fontWeight: 700,
            color: "#0e3c66",
            textAlign: "center",
            mb: 2,
          }}
        >
          EWO Discrepancy
        </Typography>

        {!activeLoading && (
          <StickyCardsContainer>
            {/* ── Row 1: View dropdown | Date button | Total ── */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                mb: 1,
                flexWrap: "nowrap",
              }}
            >
              {/* View selector */}
              <FormControl size="small" sx={{ minWidth: 200, flexShrink: 0 }}>
                <InputLabel sx={{ fontFamily: "'Poppins', sans-serif" }}>View</InputLabel>
                <Select
                  value={view}
                  label="View"
                  onChange={(e) => setView(e.target.value)}
                  sx={{
                    borderRadius: "20px",
                    fontFamily: "'Poppins', sans-serif",
                    height: "44px",
                  }}
                >
                  <MenuItem value={VIEW_IWO_WITHOUT_EWO}>IWO Without EWO</MenuItem>
                  <MenuItem value={VIEW_EWO_WITHOUT_INVOICE}>EWO Without Invoice</MenuItem>
                  <MenuItem value={VIEW_DATE}>By Date</MenuItem>
                </Select>
              </FormControl>

              {/* Date picker — only shown in By Date view */}
              {view === VIEW_DATE && (
                <Button
                  variant="contained"
                  startIcon={<CalendarTodayIcon />}
                  onClick={() => setOpenDatePicker(true)}
                  sx={{
                    height: "44px",
                    borderRadius: "20px",
                    backgroundColor: "#142c54",
                    fontWeight: "bold",
                    textTransform: "none",
                    whiteSpace: "nowrap",
                    flexShrink: 0,
                    px: 2,
                  }}
                >
                  {formatDate(selectedDate)}
                </Button>
              )}

              {/* Total */}
              <Box
                sx={{
                  background: "#e8f0fa",
                  borderRadius: "20px",
                  height: "44px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  px: 2.5,
                  flexShrink: 0,
                }}
              >
                <Typography sx={{ fontWeight: 700, fontSize: "14px", color: "#142c54", whiteSpace: "nowrap" }}>
                  Total: {totalRecords}
                  {searchTerm.trim() && sortedData.length !== totalRecords && (
                    <Typography
                      component="span"
                      sx={{ fontWeight: 400, fontSize: "12px", color: "#666", ml: 1 }}
                    >
                      (of {sortedData.length})
                    </Typography>
                  )}
                </Typography>
              </Box>
            </Box>

            {/* ── Row 2: Export PDF | Export Excel ── */}
            {filteredData.length > 0 && (
              <Box sx={{ mb: 1, display: "flex", gap: 1.5 }}>
                <Button
                  variant="contained"
                  startIcon={<DownloadIcon />}
                  onClick={handleExportPDF}
                  disabled={activeLoading || !filteredData.length}
                  sx={{
                    flex: 1,
                    height: "44px",
                    borderRadius: "20px",
                    backgroundColor: "#2e7d32",
                    color: "#fff",
                    fontWeight: "bold",
                    textTransform: "none",
                    fontSize: "15px",
                    "&:hover": { backgroundColor: "#1b5e20" },
                    "&:disabled": { backgroundColor: "#cccccc", color: "#666666" },
                  }}
                >
                  Export PDF
                </Button>

                <Button
                  variant="contained"
                  startIcon={<DownloadIcon />}
                  onClick={handleExportExcel}
                  disabled={activeLoading || !filteredData.length}
                  sx={{
                    flex: 1,
                    height: "44px",
                    borderRadius: "20px",
                    backgroundColor: "#1565c0",
                    color: "#fff",
                    fontWeight: "bold",
                    textTransform: "none",
                    fontSize: "15px",
                    "&:hover": { backgroundColor: "#0d47a1" },
                    "&:disabled": { backgroundColor: "#cccccc", color: "#666666" },
                  }}
                >
                  Export Excel
                </Button>
              </Box>
            )}

            {/* Search bar */}
            <Box sx={{ mb: 1 }}>
              <TextField
                fullWidth
                size="small"
                placeholder="Search by Job Description, Cat or Main..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ color: "#154C79" }} />
                    </InputAdornment>
                  ),
                  sx: {
                    borderRadius: "20px",
                    fontFamily: "'Poppins', sans-serif",
                    fontSize: "14px",
                    height: "44px",
                    backgroundColor: "#f5f7fb",
                    "& fieldset": { borderColor: "#d0d9e8" },
                    "&:hover fieldset": { borderColor: "#154C79" },
                    "&.Mui-focused fieldset": { borderColor: "#154C79" },
                  },
                }}
              />
            </Box>

            {openDatePicker && (
              <DatePicker
                open={openDatePicker}
                value={selectedDate}
                onChange={handleDateChange}
                onClose={() => setOpenDatePicker(false)}
                renderInput={(params) => (
                  <TextField {...params} sx={{ display: "none" }} />
                )}
              />
            )}
          </StickyCardsContainer>
        )}

        <Box sx={{ mt: 2 }}>
          <StyledTableContainer component={Paper}>
            <Table>
              <TableHead>
              <TableRow>
                {columns.map((col) => (
                  <StyledTableCell
                    key={col.key}
                    sx={{
                      textAlign: col.headerAlign,
                      whiteSpace: "nowrap",
                      minWidth: col.width ? `${col.width}px` : undefined,
                    }}
                  >
                    {col.label}
                  </StyledTableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {activeLoading ? (
                Array.from({ length: 6 }).map((_, rowIndex) => (
                  <TableRow key={`skeleton-${rowIndex}`}>
                    {columns.map((col) => (
                      <StyledTableCell
                        key={col.key}
                        sx={{
                          minWidth: col.width ? `${col.width}px` : undefined,
                        }}
                      >
                        <Skeleton
                          variant="text"
                          animation="wave"
                          width="80%"
                          sx={{
                            mx: col.align === "center" ? "auto" : col.align === "right" ? "0 0 0 auto" : 0,
                          }}
                        />
                      </StyledTableCell>
                    ))}
                  </TableRow>
                ))
              ) : filteredData.length > 0 ? (
                filteredData.map((item, index) => (
                  <StyledTableRow
                    key={index}
                    onClick={() => setSelectedRow(selectedRow === index ? null : index)}
                    sx={
                      selectedRow === index
                        ? {
                            backgroundColor: "rgba(21, 76, 121, 0.18) !important",
                            outline: "2px solid #154C79",
                            outlineOffset: "-2px",
                          }
                        : {}
                    }
                  >
                    {columns.map((col) => (
                      <StyledTableCell
                        key={col.key}
                        sx={{
                          textAlign: col.align,
                          minWidth: col.width ? `${col.width}px` : undefined,
                          whiteSpace: TASK_KEYS.has(col.key) ? "normal" : "nowrap",
                          maxWidth: TASK_KEYS.has(col.key) ? "200px" : undefined,
                          wordBreak: TASK_KEYS.has(col.key) ? "break-word" : undefined,
                          lineHeight: TASK_KEYS.has(col.key) ? 1.6 : undefined,
                        }}
                      >
                        {formatCellValue(col.key, item[col.key])}
                      </StyledTableCell>
                    ))}
                  </StyledTableRow>
                ))
              ) : (
                <TableRow>
                  <StyledTableCell colSpan={columns.length}>
                    {searchTerm.trim()
                      ? `No records match "${searchTerm}"`
                      : "No Records Found"}
                  </StyledTableCell>
                </TableRow>
              )}
            </TableBody>
            </Table>
          </StyledTableContainer>
        </Box>
      </PageContainer>
    </LocalizationProvider>
  );
}